import { LayoutItem } from "../interfaces";

/**
 * Layout: Nigerian
 * Source: Benson Muite (https://github.com/bkmgit)
 */
export default <LayoutItem>{
  layout: {
    default: [
      "\u00A7 1 2 3 4 5 6 7 8 9 0 + \u00B4 {bksp}",
      "q w e r t y u i o p \u00E5 ¨",
      "a s d f g h j k l \u00F8 \u00E6 '",
      "{shift} < z x c v b n m , . - {shift}",
      ".com @ {space} {enter}",
    ],
    shift: [
      '\u00B0 ! " # $ % & / ( ) = ? ` {bksp}',
      "Q W E R T Y U I O P \u00C5 ^",
      "A S D F G H J K L \u00D8 \u00C6 *",
      "{shift} > Z X C V B N M ; : _ {shift}",
      ".com @ {space} {enter}",
    ],
  },
};
